import { QueryParamsEntities } from "@/domain/entities/MainApp";
import { ConvertObjectCamelToSnakeCase } from '@/app/infrastructures/misc/Utils';

export class CourierSummaryRequest {
  startDate = "";
  endDate = "";
  courierId = 0 as number | string;
  status = "";
  q = "";
  shipmentType = "";

  constructor(fields?: Partial<CourierSummaryRequest>) {
    Object.assign(this, fields);
  }

  toQueryString(): string {
    return new QueryParamsEntities(this).queryString;
  }
}

export class ShipmentListRequest {
  courierId = 0 as number | string;
  startDate = "";
  endDate = "";
  status = "";
  q = "";
  shipmentType = "";
  page = 1;
  limit = 10;
  sortBy = "";
  orderBy = "";

  constructor(fields?: Partial<ShipmentListRequest>) {
        Object.assign(this, fields);
  }

  toQueryString(): string {
    return new QueryParamsEntities(this).queryString;
  }
}

export class PickupShipmentRequest {
  startDate = "";
  endDate = "";
  courierId = 0;
  status = "";
  q = "";
  shipmentType = "";
  page = 1;
  limit = 10;
  sortBy = "";
  orderBy = "";

  constructor(fields?: Partial<PickupShipmentRequest>) {
    Object.assign(this, fields);
  }

  toQueryString(): string {
    return new QueryParamsEntities(this).queryString;
  }
}

export class CourierListRequest {
  page = 0;
  limit = 10;
  startDate = "";
  endDate = "";
  q = "";
  status = "";
  shipmentType = "";
  sortBy = "";
  orderBy = "";

  constructor(fields?: Partial<CourierListRequest>) {
    Object.assign(this, fields);
  }

  toQueryString() {
    return new QueryParamsEntities(this).queryString;
  }
}

export class ManualAssignRequest {
  courierId = 0;
  shipmentId: string[] = [];
  manualAssignDate = "";

  constructor(fields?: Partial<ManualAssignRequest>) {
    Object.assign(this, fields);
  }

  toJSON(): string {
    return JSON.stringify(ConvertObjectCamelToSnakeCase(this));
  }
}

